import React from 'react';
import { createInputsWrapper, EmailValidator, ErrorText, Images, useGlobalStyles } from 'utils';
import { MaskInput, ValidationInput } from 'components';
import { customerInformation } from '../../customerInfo/core';

export const CustomerContactInfo = ({
                                      inputs,
                                      setInputs,
                                      error,
                                      setError,
                                      disables,
                                    }) => {
  const classes = customerInformation();
  const globalWrapper = useGlobalStyles();
  const globalScreens = createInputsWrapper();
  const lastContact = inputs?.contacts?.[inputs?.contacts?.length - 1];

  const handleChange = (e, index) => {
    const params = { ...inputs };
    params.contacts[index][e.target.name] = e.target.value;
    setInputs(params);
    error === e.target.name && setError('');
  };

  const addNewRow = () => {
    if (lastContact?.contactName || lastContact?.contactEmail || lastContact?.contactPhone) {
      const params = {
        ...inputs,
      };
      params.contacts.push({
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      });
      setInputs(params);
    } else {
      setError(
        !lastContact.contactName ? 'contactName' :
          !lastContact.contactEmail ? 'contactEmail' :
            !lastContact.contactPhone ? 'contactPhone' : '',
      );
    }
  };

  return (
    <div className={classes.infoWrapper}>

      <div className={classes.contactInfoTitleBox}>
        <p>Contact information</p>
        <button
          disabled={disables}
          style={{ opacity: disables ? 0.5 : 1 }}
          onClick={addNewRow}
        >
          <img src={Images.addPlusBlue} alt="add" />
          <span>Add More</span>
        </button>
      </div>

      {inputs?.contacts?.map((item, index) => {
        return (
          <div key={index} className={globalScreens.basicInfoInputs}>
            <ValidationInput
              style={globalWrapper.simpleInput}
              variant={'outlined'}
              name={'contactName'}
              type={'text'}
              label={'Name'}
              typeError={error === 'contactName' && index === inputs?.contacts?.length - 1 ? ErrorText.field : ''}
              onChange={(e) => handleChange(e, index)}
              value={item?.contactName}
              disabled={disables}
            />
            <ValidationInput
              // className={info && globalWrapper.inputTextFieldBlue}
              style={globalWrapper.simpleInput}
              variant={'outlined'}
              name={'contactEmail'}
              type={'email'}
              label={'Email Address'}
              typeError={error === 'contactEmail' && index === inputs?.contacts?.length - 1 ? ErrorText.field : ''}
              // sendBoolean={handleCheck}
              onChange={(e) => handleChange(e, index)}
              value={item.contactEmail}
              disabled={disables}
            />
            <MaskInput
              styles={{marginRight: 16}}
              name="contactPhone"
              label="Phone Number"
              value={item?.contactPhone}
              disables={disables}
              handleChange={(e) => handleChange(e, index)}
              error={error === 'contactPhone'  && index === inputs?.creditInfo?.length - 1  ? ErrorText.field : ''}
            />
            <button
              className="reset-btn"
              style={{ opacity: (inputs?.contacts?.length === 1 || disables) ? 0.5 : 1, width: 50, height: 50 }}
              disabled={disables ? disables : inputs?.contacts?.length === 1}
              onClick={() => {
                const params = {
                  ...inputs,
                };
                params.contacts.splice(index, 1);
                setInputs(params);
              }}
            >
              <img src={Images.redTrash} alt="remove" />
            </button>
          </div>
        );
      })}
    </div>
  );
};